import script from "./grid-col-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./grid-col-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./grid-col-setting-ly.vue?vue&type=style&index=0&id=e6ad4f42&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ad4f42"]])

export default __exports__